<template>
	<div class="insideBody">
		<div class="studyReport">
			
			<div class="main">
				
				<div class="conTop on clr">
					<div class="export fr">导出学习报告</div>
				</div>
				
				<div class="data_top">
					<ul>
						<li class="li2">
							<div class="tit">总学习时长</div>
							<div class="text"><span>265</span>分钟</div>
						</li>
						<li class="li1">
							<div class="tit">学习次数</div>
							<div class="text"><span>21</span>次</div>
						</li>
						<li class="li3">
							<div class="tit">总获得积分</div>
							<div class="text"><span>206</span>积分</div>
						</li>
					</ul>
				</div>
				
				<div class="data_list">
					<div class="tits">
						学习时间柱状图
						<div class="name_list name_list1 fr">有效时长</div>
						<div class="name_list name_list2 fr">学习时长</div>
					</div>
					<div id="Chart" class="Chart"></div>
				</div>
				
			</div>
			
			<div class="details hide"> <!-- 详情 -->
				<div class="data_list">
					<div class="tits">
						音标突击测试成绩
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="120"
								label="时间">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="80"
								label="单元">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="100"
								label="学习时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="80"
								label="成绩">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="80"
								label="积分">
								<template slot-scope="scope">
									<span class="red">{{scope.row.date5}}</span>
								</template>>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
			
			</div>
		
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
			tableData: [{
				date1: '2020-06-24 14：30',
				date2: 'unit 1',
				date3: '15分30秒',
				date4: '9/10',
				date5: '+15',
			}, {
				date1: '2020-06-24 14：30',
				date2: 'unit 1',
				date3: '15分30秒',
				date4: '9/10',
				date5: '+15',
			}]
		};
	},
	created(){
		
	},
	methods:{
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				legend: { 
					left:'right',
					top: 0,
					data:[]//['学习时长','有效时长']
				},
				grid: {
					left: 10,
					right: 40,
					bottom: 0,
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						name: '日期',
						data: ['4/20','4/21','4/22','4/23','4/24','4/25','4/26','4/27','4/28','4/29','4/30','5/01']
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '时间/分钟',
					}
				],
				series: [
					{
						name:'学习时长',
						type:'bar',
						stack: '日期',
						color: "#cccccc",
						data: [40,20,30,25,40,25,60,40,20,30,25,40]
					},
					{
						name:'有效时长',
						type:'bar',
						stack: '日期',
						color: "#4069fa",
						data: [50,20,30,25,50,25,60,40,20,30,25,40]
					},
				]
			});
		}
	},
	mounted(){
		var that = this;
		
		that.Chart();
	}
}
</script>
<style scoped>
	
</style>